import { useTranslation } from 'react-i18next'

import { stopPropagation } from '../../../../utils/events'
import { FileIcon } from '../../../FileIcon'
import { FloatingTooltipContentText } from '../../../Floating'
import { getTagActionSize, Tag, TAG_HEIGHT } from '../../../Tag'

import * as styles from './ListItem.module.css'

function ListItem({ filename, id, mime_type, tooltipHintKey, onClick }) {
  const { t } = useTranslation()

  const height = TAG_HEIGHT.height28

  const file = { mime_type, name: filename }

  function handleClick(e) {
    stopPropagation(e)

    onClick?.(id)
  }

  return (
    <Tag
      beforeContent={<FileIcon file={file} size={getTagActionSize(height)} />}
      className={styles.listItem}
      height={height}
      text={filename}
      tooltip={
        <FloatingTooltipContentText
          additionalText={t(tooltipHintKey)}
          text={filename}
        />
      }
      onClick={handleClick}
    />
  )
}

export default ListItem
